'use client';
import { NavbarBrand, Navbar, NavbarItem, NavbarContent } from '@heroui/react';
import Image from 'next/image';
import React, { useState } from 'react';
import MobileNavbarMenu from './mobile-navbar-menu';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { navigationLinks } from '../config/navigation-links';
import { useTranslations } from 'next-intl';
import { useCustomizationsContext } from '../customizations-provider';
import MarkdownLink from './markdown-link';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathName = usePathname();
  const isAboutPage = pathName == '/about';
  const t = useTranslations('menu');
  const c = useCustomizationsContext();
  const logo = isAboutPage ? c('heldenstrom.white') : c('heldenstrom.black');

  return (
    <div className="absolute w-full z-50 my-6">
      <Navbar
        isMenuOpen={isMenuOpen}
        onMenuOpenChange={setIsMenuOpen}
        maxWidth="full"
        classNames={{
          wrapper: 'mb-4 md:mb-6 h-5 md:h-[42px]',
        }}
      >
        <NavbarContent justify="start">
          <NavbarBrand>
            <Link href="/">
              <Image
                src={logo.url}
                alt={logo.description}
                height={logo.height}
                width={logo.width}
                unoptimized={true}
                className="h-5 md:h-[33px] w-[160px] md:w-[261px]"
              />
            </Link>
          </NavbarBrand>
          <div
            className={`hidden md:flex flex-row gap-[30px] font-montserrat text-xl ml-[30px] ${isAboutPage ? 'text-white' : 'text-black'}`}
          >
            {navigationLinks(t).map((item) => (
              <NavbarItem
                key={item.label}
                className={`pt-1 ${pathName == item.link ? 'font-bold' : null}`}
              >
                <MarkdownLink text={item.label} />
              </NavbarItem>
            ))}
          </div>
        </NavbarContent>
        <MobileNavbarMenu
          isMenuOpen={isMenuOpen}
          isAboutPage={isAboutPage}
          setIsMenuOpen={setIsMenuOpen}
        />
      </Navbar>
    </div>
  );
}
